import { css } from "@emotion/react";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";

//------------------------------------------------------------------------------------
/* ItemName */
export const ItemNameField = () => {
	const productDetailsState = useProductDetailsState();
	return (
		<div
			css={css`
                font-weight: 600;
                font-size: 1.2rem;
                letter-spacing: -1px;
                padding: 1rem 0;
                min-width: 350px;
                `}
		>
			{productDetailsState.get().product?.ItemName}
		</div>
	);
};
